/**
 * Breadcrumb display text mappings
 * Maps route names to their display text in breadcrumb navigation
 */
export const BREADCRUMB_LABELS = {
    'browse-all': 'Browse',
    browse: 'All',
    'browse-connectors': 'Directory',
    'browse-opportunities': 'Opportunities',
    'browse-volunteers': 'Volunteers',
    'share-my-career': 'Volunteer Career Shares',
    'opportunity-details': 'Career Connect Details',
    'direct-request': 'Direct Request',
    'request-directory': 'All',
    'requests-active': 'Active',
    'requests-past': 'Past',
    'new-request': 'New Request',
    'employee-profile-public': 'Profile',
    settings: 'Settings',
    'employee-resources': 'Resources',
    'employee-dashboard': 'Dashboard',
    'volunteer-profile': 'Volunteer Profile',
    dashboard: 'Dashboard',
    'asset-details': 'Content Details',
    'browse-organizations': 'Organizations',
    'connect-directory': 'Request Hub',
    'request-details': 'Request Details',
    'request-edit': 'Edit Request',
    'browse-content': 'Browse Content',
    'request-templates': 'Request Templates',
    'organization-content': 'Content',
    'user-management': 'User Management',
    'organization-settings': 'Settings & Preferences',
    'new-opportunity': 'Share My Career',
    'edit-opportunity': 'Edit My Career Share',
    message: 'Messages',
    'org-management': 'Manage Organizations',
    'educator-management': 'Manage Educators',
    'request-admin': 'Request Admin',
    'feature-flags': 'Feature Flags',
    'how-it-works': 'How it Works',
    'browse-groups': 'Browse Groups',
    'group-details': 'Group Details',
    'new-group': 'Create a New Group',
    'edit-group': 'Edit Group',
    'group-admins': 'Group Admins',
    'group-statistics': 'Group Statistics',
    'new-request-v2': 'Create a Request',
    'request-edit-v2': 'Edit Your Request',
    'request-duplicate': 'Duplicate a Request',
};

/**
 * Role-specific breadcrumb text overrides
 * Some breadcrumbs change text based on user role
 */
export const ROLE_SPECIFIC_LABELS = {
    'connect-directory': {
        educator: 'Connect Hub',
        default: 'Request Hub',
    },
};
